<div class="container" [ngStyle]="{'justify-content': align=='left'?'flex-start':'flex-end',
                                   'margin-top': marginTop,
                                   'margin-bottom': marginBottom}">
    <ng-content></ng-content>
</div>
